<template>
  <div class="radial-progress text-primary" :style="`--value:${progress};`" role="progressbar">{{ progress }}%</div>
</template>

<script>
export default {
  props: {
    progress: {
      type: Number,
      required: true,
    },
  },
};
</script>
